import React from 'react'
import { styled } from '~/app/components'

/**
 * NoticeView component
 * author: soojin.oh
 */

// type definitions
export type NoticeViewProps = { title?: string | null; contents?: string[] }

const NoticeViewItem = styled.li`
  word-break: break-all;
`

// NoticeView component
const NoticeView: React.FunctionComponent<NoticeViewProps> = function ({ title, contents }) {
  return (
    <>
      <div className={'subtitle'}>{title}</div>
      <ul style={{ width: '100%' }}>
        {contents?.map((content, index) => (
          <NoticeViewItem key={index}>{content}</NoticeViewItem>
        ))}
      </ul>
    </>
  )
}

export default NoticeView
